import { DefaultButton } from "../buttons/DefaultButton";
import { IconLink } from "../../assets/icons/icons";
import { RefreshCcw } from "lucide-react";

interface IntegrationCardInfoProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  error?: string;
  syncButtonText?: string;
  onSyncOrder?: () => void;
}

export const IntegrationCardInfo = ({
  title,
  description,
  buttonText,
  buttonLink,
  error,
  syncButtonText,
  onSyncOrder,
}: IntegrationCardInfoProps) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{title}</h2>

      <div className="space-y-1 text-gray-700">
        <p>{description}:</p>

        {error && <p className="">{error}</p>}
      </div>

      {buttonText && buttonLink && (
        <div className="flex justify-end py-4">
          <DefaultButton
            title={buttonText}
            onClick={() => {
              window.open(buttonLink, "_blank");
            }}
            isLoading={false}
            icon={
              <IconLink color={"#5050EA"} width="20px" height="20px" />
            }
          />
        </div>
      )}

      {/* {error && syncButtonText && onSyncOrder && (
        <div className="flex justify-start py-4">
          <DefaultButton
            title={syncButtonText}
            onClick={onSyncOrder}
            isLoading={false}
            icon={<RefreshCcw />}
          />
        </div>
      )} */}
    </div>
  );
};
